:host(c-swiper-tab) {
  /**
   * @prop --c-swiper-tab-background-color-active: Swiper active background color
   * @prop --c-swiper-tab-background-color-disabled: Swiper disabled background color
   * @prop --c-swiper-tab-background-color: Swiper background color
   * @prop --c-swiper-tab-hover-color: Swiper hover color
   * @prop --c-swiper-tab-text-color-active: Swiper active text color
   * @prop --c-swiper-tab-text-color-disabled: Swiper disabled text color
   * @prop --c-swiper-tab-text-color: Swiper text color
   */
  --_c-swiper-tab-background-color-active: var(--c-swiper-tab-background-color-active, var(--c-primary-600));
  --_c-swiper-tab-background-color-disabled: var(--c-swiper-tab-background-color-disabled, var(--c-tertiary-100));
  --_c-swiper-tab-background-color: var(--c-swiper-tab-background-color, var(--c-primary-200));
  --_c-swiper-tab-hover-color: var(--c-swiper-tab-hover-color, var(--c-primary-100));
  --_c-swiper-tab-text-color-active: var(--c-swiper-tab-text-color-active, var(--c-white));
  --_c-swiper-tab-text-color-disabled: var(--c-swiper-tab-text-color-disabled, var(--c-tertiary-600));
  --_c-swiper-tab-text-color: var(--c-swiper-tab-text-color, var(--c-primary-600));

  border-radius: 8px;
  width: 100%;
  height: 100%;
  outline: none;
  text-decoration: none;
  user-select: none;
  display: grid;
  align-content: stretch;
  padding: 4px;
  background-color: transparent;
  border: none;
}

:host(:focus) {
  outline: 2px var(--_c-swiper-tab-background-color-active) solid;
  outline-offset: -2px;
}

@supports selector(:focus-visible) {
  :host(:focus) {
    outline: none;
  }
}

:host(:focus-visible) {
  outline: 2px var(--_c-swiper-tab-background-color-active) solid;
  outline-offset: -2px;
}

.c-swiper-tab {
  $this: &;

  height: 100%;

  &:hover:not(#{$this}--active):not(#{$this}--disabled) {
    #{$this}__content {
      background-color: var(--_c-swiper-tab-hover-color);
    }
  }

  &__content {
    border-radius: 6px;
    background-color: var(--_c-swiper-tab-background-color);
    color: var(--_c-swiper-tab-text-color);
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;
    display: grid;
    gap: 4px;
    grid-template-columns: 1fr;
    line-height: 1.5;
    padding: 16px;
    align-content: start;
    position: relative;
    overflow: hidden;
    height: 100%;
  }

  &__header {
    line-height: 38px;
    font-size: 24px;
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 16px;
  }

  &__description {
    align-items: start;
    opacity: 0.67;
  }

  &--disabled {
    #{$this}__content {
      background: var(--_c-swiper-tab-background-color-disabled);
      color: var(--_c-swiper-tab-text-color-disabled);
      cursor: default !important;
      pointer-events: none;
    }
  }

  &--active {
    #{$this}__content {
      background-color: var(--_c-swiper-tab-background-color-active);
      color: var(--_c-swiper-tab-text-color-active);
      pointer-events: none;

      &:hover {
        background-color: var(--_c-swiper-tab-background-color-active);
      }
    }
  }

  svg {
    fill: currentColor;
    height: 38px;
    width: 38px;
  }
}
